var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMountainsmin = function SvgMountainsmin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 203 102"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mountains_min_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF3DBC",
    d: "m101.15 0 81.54 106.5H19.61L101.15 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m101.15 0 24.3 31.74h-48.6L101.15 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50005F",
    fillOpacity: 0.8,
    d: "m51.5 28 49.8 78H1.7l49.8-78Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m51.5 28 20.25 31.71h-40.5L51.5 28Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50005F",
    fillOpacity: 0.6,
    d: "m144 45 61.49 62.25H82.5L144 45Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m144 45 25 25.31h-50L144 45Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mountains_min_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h203v102H0z"
  })))));
};
export default SvgMountainsmin;